import { parse, ParsedQs, stringify } from "qs";
import { NavigateFunction } from "react-router-dom";

function changeURL(navigate: NavigateFunction, url: string, _: boolean = true) {
    const u = new URL(url, window.location.href);
    navigate({
        pathname: u.pathname,
        search: u.search,
    });
}

/** Key-value tuple for defining a query param */
type ParamKeyValue = [string, string | string[] | ParsedQs | ParsedQs[]];

/** Changes the URL by updating the query parameters.
 * @param navigate - The navigate function from react-router-dom.
 * @param keyValues - An array of key-value pairs to update in the query parameters.
 * @example
 * changeQuery(navigate, ["page", "2"], ["sort", "name"]); // Query will be updated to ?page=2&sort=name
 * */
export function changeQuery(navigate: NavigateFunction, ...keyValues: ParamKeyValue[]) {
    const uri = new URL(window.location.href);
    const params = parse(uri.search, { ignoreQueryPrefix: true });

    for (const [key, value] of keyValues) params[key] = value;

    uri.search = stringify(params, { addQueryPrefix: true });
    changeURL(navigate, uri.toString());
}
